import api from "./apiHelper";

export const createProduct = (payload) => {
  return api.post(`/product/add`, payload);
};

export const getAllProducts = (mode) => {
  return api.get(`/product?mode=` + mode);
};

export const patchProduct = (productId, payload) => {
  return api.patch(`/product/` + productId, payload);
};

export const archiveProduct = (productId) => {
  return api.patch(`/product/archive/` + productId);
};

export const syncProducts = () => {
  return api.post(`/product/sync`);
};
